// extracted by mini-css-extract-plugin
export var contentContainer = "styles-module--contentContainer--Nc+yo";
export var disclaimerHeader = "styles-module--disclaimerHeader--QCnlz";
export var disclaimerText = "styles-module--disclaimerText--qCxJF";
export var landingCtaDisclaimerWrapper = "styles-module--landingCtaDisclaimerWrapper--tFgoJ";
export var primary = "#06004d";
export var secondary = "#4dafd7";